<template>
  <div>
    <div class="scrollCardStudio-1">
      <div class="scrollContentTitle">
        <h6 class="title title-up text-center navHeadline">Studio</h6>
        <h4 class="text-center title navHeadlineText"></h4>
      </div>

      <el-carousel :interval="4000" arrow="always">
        <el-carousel-item v-for="item in carousselData" :key="item">
          <!--<h3>{{ item }}</h3>-->
          <img class="d-block" :src="item.src" :alt="item.title" />
        </el-carousel-item>
      </el-carousel>
<!--
      <el-carousel>
        <el-carousel-item>
          <img class="d-block" src="img/caroussel/eingang.jpg" alt="Eingang" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Eingang</h5>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img class="d-block" src="img/caroussel/tresen.jpg" alt="Tresen" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Tresen</h5>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img class="d-block" src="img/caroussel/eingang2.jpg" alt="Eingang 2" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Eingang 2</h5>
          </div>
        </el-carousel-item>
      </el-carousel>-->
    </div>
  </div>
</template>

<script>
    import { Carousel, CarouselItem } from 'element-ui';

    export default {
        name: "Studio",
        data: function () {
          return {
            carousselData: [
              {src: "img/caroussel/eingang.jpg", title: "Eingang"},
              {src: "img/caroussel/tresen.jpg", title: "Tresen"},
              {src: "img/caroussel/eingang2.jpg", title: "Eingang2"}
            ]
          }
        },
        components: {
          [Carousel.name]: Carousel,
          [CarouselItem.name]: CarouselItem
        }
    }
</script>

<style scoped>
.el-carousel__container{
  height: 869px !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>